import { Stack, Accordion, Text, Loader, Avatar } from '@mantine/core';
import { useSearchParams } from 'react-router-dom';
import type { TSearchResult } from '@newo/api/gateway';
import { FileSearch } from 'lucide-react';
import { NoResultsState, SearchResultItem } from './components';

interface SearchResultsContentProps {
    searchResults?: TSearchResult[];
    isLoading: boolean;
    query: string;
}

const SearchResultsContent = ({
    searchResults,
    isLoading,
    query
}: SearchResultsContentProps) => {
    const [searchParams] = useSearchParams();

    if (query === '') {
        return (
            <Stack align="center" gap="sm" h={300} justify="center">
                <Avatar color="gray" radius="sm">
                    <FileSearch />
                </Avatar>
                <Text c="dimmed" size="sm" ta="center">
                    Start typing to search ...
                </Text>
            </Stack>
        );
    }

    if (isLoading) {
        return (
            <div className="flex justify-center items-center py-16">
                <Loader size="lg" />
            </div>
        );
    }

    if (!searchResults?.length) {
        return <NoResultsState />;
    }

    return (
        <Stack gap="md">
            <Text c="dimmed" size="sm">
                {searchResults.length} match
                {searchResults.length === 1 ? '' : 'es'} found
            </Text>
            <Accordion variant="contained">
                {searchResults.map((result, index) => (
                    <SearchResultItem
                        index={index}
                        key={`${result.data.project_id}-${result.data.id}-${index}`}
                        result={result}
                        searchParams={searchParams}
                    />
                ))}
            </Accordion>
        </Stack>
    );
};

export default SearchResultsContent;
